// extracted by mini-css-extract-plugin
export default {"tab_container":"MultiTab_tab_container__kHgbe","tab_text":"MultiTab_tab_text__1-6E5"};